import { render } from "./Pdf.vue?vue&type=template&id=9225a202"
import script from "./Pdf.js?vue&type=script&lang=js"
export * from "./Pdf.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__